import { jsx, jsxs } from "react/jsx-runtime";
const AlertTriangle = ({ className = 'tw-text-neutral-light-800', size = 32 })=>/*#__PURE__*/ jsxs("svg", {
        className: className,
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        children: [
            /*#__PURE__*/ jsx("path", {
                d: "M13 9a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0V9ZM13 15a1 1 0 1 0-2 0v.01a1 1 0 1 0 2 0V15Z",
                fill: "none",
                className: "tw-fill-current"
            }),
            /*#__PURE__*/ jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.99 1.968a3 3 0 0 0-2.62 1.538L2.275 15.75a.996.996 0 0 0-.062.125 3 3 0 0 0 2.625 4.125c.037.002.072.002.107 0L5 20h14.007a3 3 0 0 0 2.76-4.125.999.999 0 0 0-.062-.126L14.61 3.506a3 3 0 0 0-2.62-1.538ZM5 18c-.019 0-.037 0-.055.002H4.94a1 1 0 0 1-.895-1.321l7.06-12.18.009-.017a1 1 0 0 1 1.75 0l.01.017 7.058 12.179a1 1 0 0 1-.937 1.32H5Z",
                fill: "none",
                className: "tw-fill-current"
            })
        ]
    });
const AlertTriangle_AlertTriangle = AlertTriangle;
export default AlertTriangle_AlertTriangle;
